import { defineTool } from '@/shell/tool';

/** Forms: Vibes' form builder in a frame (Flutter's `forms` embed). */
export default defineTool({
  id: 'vibes-forms',
  title: 'Forms',
  summary: "Vibes' form builder, in a frame.",
  section: 'vibes',
  order: 30,
  icon: 'description',
  owner: '@Drabu',
  permission: 'vibes-forms:use',
  routes: () => import('./FormsPage'),
});
